import styled from 'styled-components';
import Image from '../../common/Image/Image';
import {ButtonBase, CenteredDivWrap} from '../../../CommonStyleUtils/dwebCommon.styles';

export const AdvertisementUIMainWrapper = styled.section(
  props => `
  max-width: 90rem;
  margin: 0 auto;
  margin-top: ${props.theme.spacing.xxlarge};
  width:100%;
  position:relative;
  `,
);

export const AdvertisementImg = styled(Image)(
  props => `
    height:8rem;
    width:100%;
    object-fit: fill;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    `,
);

export const ExploreBtm = styled(ButtonBase)(
  props => `
    font-size: ${props.theme.font.custom(14)};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.custom(25)};
    box-shadow: 0 0.2rem 1.2rem 0 ${props.theme.colors.shadow.light};
    position: absolute;
    color:${props.theme.colors.goBrand.blue};
    bottom: 28%;
    right: -2rem;
    transform: translateX(-50%);
    height: 3.5rem;
    width: 10rem;
    padding:${props.theme.spacing.small}
  `,
);

export const AdWrpper = styled(CenteredDivWrap)(
  props => `
    font-size: ${props.theme.font.base};
    font-weight:bold;
    border-radius: ${props.theme.misc.borderRadius.custom(15)};
    background-color: rgba(0, 0, 0, 0.5);
    // box-shadow: 0 0.2rem 1.2rem 0 ${props.theme.colors.shadow.light};
    position: absolute;
    color:${props.theme.colors.white.base};
    bottom: 9%;
    left: 0.5rem;
    width: 4rem;
    padding:${props.theme.spacing.xsmall} ${props.theme.spacing.small};
    justify-content: center;
    align-items: center;
    display: flex;

  `,
);
